import { palettes } from '@indigo-ag/component-module';
import React from 'react';
import { WithConditionalTooltip } from 'shared';
import { getExceptionText } from 'shared/utils/creditExceptions.utils';
import styled from 'styled-components';
import { baseTagStyles } from '../tag.styles';
import TagCloseButton from '../TagCloseButton';

const FLAGGED_COLOR = '#2f4f4f';
const UNFLAGGED_COLOR = '#ff8c00';

const getTagColor = (flagged?: boolean) => (flagged ? FLAGGED_COLOR : UNFLAGGED_COLOR);

const StyledTag = styled.div<{ flagged?: boolean }>`
  ${baseTagStyles}
  background-color: ${palettes.brand.yellow.lightest};
  color: ${({ flagged }) => getTagColor(flagged)};
  border: 1px solid ${({ flagged }) => getTagColor(flagged)};
`;

interface CreditExceptionTagProps {
  exception: string;
  dismissible?: boolean;
  onDismiss?: () => void;
  flagged?: boolean;
}

const CreditExceptionTag = ({ exception, dismissible, onDismiss, flagged }: CreditExceptionTagProps) => {
  return (
    <WithConditionalTooltip visible={flagged} title="Exceção adicionada em outra negociação" placement="top-start">
      <StyledTag flagged={flagged}>
        {getExceptionText(exception)}
        {dismissible && <TagCloseButton type="exception" onClick={onDismiss} />}
      </StyledTag>
    </WithConditionalTooltip>
  );
};

export default CreditExceptionTag;
